import '../css/style.scss';
import '../css/policy.scss';
import '../css/cookieconsent.scss';

const cookiesConsent = require('./func/cookies-consent');
const currentYear = require('./func/current-year');

window.addEventListener('DOMContentLoaded', run);

async function run(e) {
  
}
